import { pendingHeartRunnerListState } from '../state/pendingHeartRunnerListState'
import {
    Fetch_All_Region_Data1,FETCH_PENDING_HEARTRUNNER_REQUEST, FETCH_PENDING_HEARTRUNNER_SUCCESS, FETCH_PENDING_HEARTRUNNER_ERROR,
    UPDATE_PENDING_HEARTRUNNER_REQUEST, UPDATE_PENDING_HEARTRUNNER_SUCCESS, UPDATE_PENDING_HEARTRUNNER_ERROR
} from '../actions/pendingHeartRunnerListAction'

var initialStatusCode=''

export function pendingHeartRunnerReducer(state = pendingHeartRunnerListState, action) {
    switch (action.type) {
        case FETCH_PENDING_HEARTRUNNER_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                statusCode:initialStatusCode,
                errorMessage:''
            })
        case FETCH_PENDING_HEARTRUNNER_SUCCESS:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                pendingHeartRunnerList: action.pendingHeartRunnerList,
                statusCode : action.statusCode
            })
        case FETCH_PENDING_HEARTRUNNER_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage
            })
        case UPDATE_PENDING_HEARTRUNNER_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                statusCode:initialStatusCode,
                errorMessage :''
            })
        case UPDATE_PENDING_HEARTRUNNER_SUCCESS:
            
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                pendingHeartRunnerList: action.pendingHeartRunnerList,
                errorMessage: action.messageLabel,
                statusCode: action.statusCode,
            })
        case UPDATE_PENDING_HEARTRUNNER_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.messageLabel
            })
             case Fetch_All_Region_Data1:
                                return Object.assign({}, state, {
                                    errorCode : action.errorCode,
                                    statusCode : action.statusCode,
                                    regionList : action.regionList
                                })
        default:
            return state;
    }
}
